import React from "react";


export function SharedViewLogo(props:any) {


    const onClick = () => {
        window.location.href = "https://www.goodday.work";
    }

    // gd.modules.sharedViews.logo ....

    return (
        <div className="btn-logo" onClick={onClick}/>
    )

}